import { DocumentCollection, DocumentResource, Resource } from 'ngx-jsonapi';
import { Account } from './account';
import { Meta } from './meta';
import { System } from './system';

export class TransactionPrivate extends Resource {
    public type: string = 'transactions';
    public attributes: {
        __operation: null | 'send' | 'receive';
        amount1: number;
        amount2: number;
        public_observation: string;
        referral_id?: string;
        mark_as_send: boolean;
    } = {
        __operation: null,
        amount1: 0,
        amount2: 0,
        public_observation: '',
        mark_as_send: false
    };

    public relationships: {
        account1: DocumentResource<Account>;
        account2: DocumentResource<Account>;
        system1: DocumentResource<System>;
        metas: DocumentCollection<Meta>;
        system2: DocumentResource<System>;
    } = {
        account1: new DocumentResource<Account>(),
        account2: new DocumentResource<Account>(),
        system1: new DocumentResource<System>(),
        metas: new DocumentCollection<Meta>(),
        system2: new DocumentResource<System>()
    };
}
